/** Stable synthetic identities shared by the customer book and calendar. */
export const DEMO_PEOPLE = [
  'Jessica Walter',
  'Lana Hvy Dinh',
  'Anna Ziegler',
  'Adama Sumaila',
  'Adel Ibrahim',
  'Ahlem Gerges',
  'Aida Jakupovic',
  'Akua Gyamfua',
  'Alexandra Leotta',
  'Barbara Schwab',
  'Birgit Riemer',
  'Carolin Haag',
  'Claudia März',
  'Daniela Gareis',
  'Eleni Papadopoulou',
  'Elisa Mueller',
]
